const membershipDropdowns = document.querySelectorAll(
	'.block-membership-dropdown'
);

const toggleDropdown = (dropdown) => {
	dropdown.classList.toggle('active');
};

const handleAccordionVisibility = (accordions, value) => {
	accordions.forEach((accordion) => {
		const terms = accordion.dataset.terms
			.split(',')
			.map((term) => term.trim());

		accordion.style.display =
			value === 'All Industries' || terms.includes(value)
				? 'block'
				: 'none';
	});
};

const toggleActiveAccordions = (e) => {
	e.preventDefault();

	const selectedOption = e.target;
	const value = selectedOption.dataset.value.trim();

	const parentSection = selectedOption.closest('.block-membership-section');
	const parentDropdown = parentSection.querySelector(
		'.block-membership-dropdown__current'
	);
	const allOptions = parentSection.querySelectorAll(
		'.block-membership-dropdown__option'
	);
	const accordions = parentSection.querySelectorAll(
		'.membership-accordion-wrapper'
	);

	// Update active states for options
	allOptions.forEach((option) => option.classList.remove('active'));
	selectedOption.classList.add('active');

	// Update accordion visibility
	handleAccordionVisibility(accordions, value);

	// Update dropdown display
	parentDropdown.innerText = value;
	parentDropdown.classList.remove('active');
};

// Handle outside click to close dropdowns
const handleOutsideClick = (event) => {
	membershipDropdowns.forEach((dropdown) => {
		const dropdownButton = dropdown.querySelector(
			'.block-membership-dropdown__current'
		);

		// Check if the click happened outside the dropdown
		if (!dropdownButton.contains(event.target)) {
			toggleDropdown(dropdown);
			dropdownButton.classList.remove('active');
		}
	});
};

if (membershipDropdowns.length) {
	membershipDropdowns.forEach((dropdown) => {
		const dropdownButton = dropdown.querySelector(
			'.block-membership-dropdown__current'
		);
		const dropdownOptions = dropdown.querySelectorAll(
			'.block-membership-dropdown__option'
		);

		// Toggle dropdown visibility on button click
		dropdownButton.addEventListener('click', (e) => {
			e.preventDefault();
			toggleDropdown(dropdownButton);
		});

		// Attach click events to dropdown options
		dropdownOptions.forEach((option) => {
			option.addEventListener('click', toggleActiveAccordions);
		});
	});

	// Add global event listener for outside clicks
	document.addEventListener('click', handleOutsideClick);
}
